import {useCallback, useState} from 'react';
import {listTypes} from '../enum';
import {formHasActiveKeys} from '../utils';
import {keys} from '../../../../../constants/KeyCodes';
import {lockScreenKeyboardNavigation} from '../../../actions/lockScreenKeyboardNavigation';

export const useDialog = (isApiLock: () => boolean) => {
    const [listType, setListType] = useState<listTypes>(null);
    const [isOpen, setOpen] = useState(false);
    const [runInSearchMode, setSearchModeFlag] = useState(false);

    const onDialogClose = useCallback(() => {
        setOpen(false);
        setSearchModeFlag(false);
        lockScreenKeyboardNavigation(false);
    }, []);

    const onDialogOpen = useCallback(
        (listType: listTypes, openInSearchMode?: boolean) => {
            setOpen(true);
            setListType(listType);
            setSearchModeFlag(openInSearchMode);
            lockScreenKeyboardNavigation(true);
        },
        [setOpen]
    );

    const handleDialogShortcut = useCallback(
        (e: KeyboardEvent) => {
            if (isOpen || isApiLock() || e.altKey) return;

            if (e.key === keys.F5 && !e.ctrlKey && formHasActiveKeys()) {
                onDialogOpen(listTypes.FormSons, e.shiftKey);
            } else if (e.key === keys.F5 && e.ctrlKey && formHasActiveKeys()) {
                onDialogOpen(listTypes.DirectActivations);
            }
        },
        [onDialogOpen, isOpen, isApiLock]
    );

    return {
        isOpen,
        listType,
        runInSearchMode,
        onDialogClose,
        onDialogOpen,
        handleDialogShortcut
    };
};
